'use client';
import React from 'react';
import styles from './article.module.css';

const Content = React.memo(({ content }) => {
  // Content is pre-processed on server, just render it
  return (
    <div
      className={`w-full no-scrollbar ${styles.articleSection}`}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
});

Content.displayName = 'Content';

export default Content;
